import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { PerformanceEvaluationsService } from '../services/openapi/api/performanceEvaluations.service';
import { PerformanceEvaluationDetail } from '../services/openapi/model/performanceEvaluationDetail';

export const evaluationDetailResolver: ResolveFn<PerformanceEvaluationDetail> = (route: ActivatedRouteSnapshot) => {
  const performanceEvaluationsService = inject(PerformanceEvaluationsService);
  const router = inject(Router);
  const id = route.paramMap.get('id');

  if (!id) {
    return new RedirectCommand(router.parseUrl('/forbidden'));
  }

  return performanceEvaluationsService.getEvaluationDetail(id).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 404) {
          return of(new RedirectCommand(router.parseUrl('/not-found')));
        }

        if (error.status === 403) {
          return of(new RedirectCommand(router.parseUrl('/forbidden')));
        }
      }

      return of(new RedirectCommand(router.parseUrl('/forbidden')));
    })
  );
};
